import React from 'react';

import Modal from '@material-ui/core/Modal';
import Paper from "@material-ui/core/Paper";
import Typography from '@material-ui/core/Typography';

import {
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({

  modalPosition: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paperBody: {
    width: 570,
    borderRadius: 4,
    boxShadow: '0 24px 40px -16px rgba(6, 31, 128, 0.2)',
    border: 'solid 1px #dfdfe6',
    backgroundColor: '#fff',
    minHeight: 400,
    maxHeight: 650,
    overflowY: 'auto',
    position: 'relative'
  },
  closeIcon: {
    position: 'absolute',
    top: 10,
    right: 10,
    fontSize: 24,
    cursor: 'pointer',
    color: '#8989a3'
  },
  bottomBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: 'solid 1.5px #dfdfe6',
    height: 80,
    padding: 20,
  },
  titulo: {
    fontSize: 16,
    fontFamily: 'IBM Plex Sans',
    color: '#061243',
    textTransform: 'uppercase'
  }

}))

const ModalDefault = (props) => {
  const {
    open,
    onClose,
    children,
    CancelButton,
    ConfirmButton,
    title
  } = props;

  const classes = useStyles();

  return (
    <>
      <Modal className={classes.modalPosition} open={open} onClose={onClose}>
        <Paper className={classes.paperBody}>
          <div style={{ minHeight: 350, padding: 20, }}>
            <p className={classes.titulo} ><strong>{title}</strong></p>
            {children}
          </div>
          <div className={classes.bottomBox}>
            <div style={{ marginRight: 10 }}>
              {CancelButton}
            </div>
            <div>
              {ConfirmButton}
            </div>
          </div>
          {/* <MdClose className={classes.closeIcon} onClick={onClose} /> */}
        </Paper>
      </Modal>
    </>
  );
}

export default ModalDefault;